import { useTranslation } from "react-i18next";
import { MdArrowLeft } from "react-icons/md";
import { ActionIcon, Group, Text } from "@mantine/core";
import { LanguageSelector } from "../../i18n";
import { CountrySelector } from "../country-selector";
import { useCountry } from "../../CountryContext";

export interface TopSectionProps {
    toggle: () => void;
    showLanguageSelector?: boolean;
}

export const TopSection = ({ toggle, showLanguageSelector: showLanguageSelector = false }: TopSectionProps) => {
    const { i18n } = useTranslation();
    return (
        <>
            <Group justify="space-between" align="center" style={theme => ({ marginBottom: theme.spacing["8"] })}>
                <ActionIcon variant="light" color="gray.1" radius="lg" onClick={toggle}>
                    <MdArrowLeft size={24} />
                </ActionIcon>
                <Group gap={0} justify="center" align="center" flex={{ grow: 1 }}>
                    <CountrySelector />

                    {showLanguageSelector && (
                        <>
                            <LanguageSelector />
                            <Text size="sm" fw={600} tt="uppercase" c="dark.4">
                                {i18n.language}
                            </Text>
                        </>
                    )}
                </Group>
            </Group>
        </>
    );
};
